import { ITopProduct, IReorderTopProductsDTO } from '@/models/products.model';

class ReorderTopProductsDTO implements IReorderTopProductsDTO {
  top_product_ids: string[];
  constructor(items: ITopProduct[]) {
    this.top_product_ids = items.map((data) => data.id);
  }
}

export default ReorderTopProductsDTO;
